
export const variants = {
  h1: {
    fontSize: '6rem',
    fontWeight: 300,
    lineHeight: 1.167,
  },
  h2: {
    fontSize: '3.75rem',
    fontWeight: 300,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '3rem',
    fontWeight: 400,
    lineHeight: 1.167,
  },
  h4: {
    fontSize: '2.125rem',
    fontWeight: 400,
    lineHeight: 1.235,
  },
  h5: {
    fontSize: '1.5rem',
    fontWeight: 400,
    lineHeight: 1.334,
  },
  h6: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.6,
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.75,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.57,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.43,
  },
  body3: {
    fontSize: '0.8rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
  },
  button: {
    fontWeight: 500,
    fontSize: '1.1rem',
    lineHeight: 2,
  },
  header: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.66,
  }
};

export const kioskVariants = {
  h1: {
    fontSize: '6rem',
    fontWeight: 300,
    lineHeight: 1.167,
  },
  h2: {
    fontSize: '3.75rem',
    fontWeight: 300,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '3rem',
    fontWeight: 400,
    lineHeight: 1.167,
  },
  h4: {
    fontSize: '2.125rem',
    fontWeight: 400,
    lineHeight: 1.235,
  },
  h5: {
    fontSize: '1.6rem',
    fontWeight: 400,
    lineHeight: 1.334,
  },
  h6: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.6,
  },
  subtitle1: {
    fontSize: '2.5rem',
    fontWeight: 400,
    lineHeight: 1.75,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.57,
  },
  body1: {
    fontSize: '1.3rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '1.2rem',
    fontWeight: 400,
    lineHeight: 1.43,
  },
  body3: {
    fontSize: '0.9rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body4: {
    fontSize: '0.65rem',
    fontWeight: 200,
    lineHeight: 1.5,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
  },
  button: {
    fontWeight: 500,
    fontSize: '1.3rem',
    lineHeight: 2.2,
  },
  header: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 1.66,
  }
};
